import type { FC } from "react";
import React from "react";

import { ButtonCellLeftIcon } from "../../../general/components/LeftIcon/ButtonCellLeftIcon";
import { createDisplayNameForButtonCellSchevronElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellSchevronElement } from "../../utils/getTestId";

import type { IButtonCellLeftIcon } from "../../../general/components/LeftIcon/ButtonCellLeftIcon";

const LEFT_ICON_TEST_ID = createTestIdForButtonCellSchevronElement("left-icon");

export const ButtonCellSchevronOptionLeftIcon: FC<IButtonCellLeftIcon> = ({
    icon,
    "data-tsid": tsid,
}) => {
    const dataTestId = tsid || LEFT_ICON_TEST_ID;

    return <ButtonCellLeftIcon icon={icon} data-tsid={dataTestId} />;
};

ButtonCellSchevronOptionLeftIcon.displayName =
    createDisplayNameForButtonCellSchevronElement("LeftIcon");

export default ButtonCellSchevronOptionLeftIcon;
